module.exports = __webpack_public_path__ + "static/media/php.f0b4239f.png";